module.exports = __webpack_public_path__ + "assets/img/172-6C6D LaVille-v6-2222.97d3c8c2.jpg";